module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-152x152-8ec8785626eb6fc3bd1938881aaf90a5.png";